"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var configuration_1 = require("./configuration");
exports.DEFAULT_CONFIGURATION = configuration_1.DEFAULT_CONFIGURATION;
var errorCollection_1 = require("./errorCollection");
exports.ErrorOrigin = errorCollection_1.ErrorOrigin;
var init_1 = require("./init");
exports.BuildMode = init_1.BuildMode;
exports.Datacenter = init_1.Datacenter;
exports.makeStub = init_1.makeStub;
exports.makeGlobal = init_1.makeGlobal;
exports.commonInit = init_1.commonInit;
exports.checkCookiesAuthorized = init_1.checkCookiesAuthorized;
exports.checkIsNotLocalFile = init_1.checkIsNotLocalFile;
var internalMonitoring_1 = require("./internalMonitoring");
exports.monitored = internalMonitoring_1.monitored;
exports.monitor = internalMonitoring_1.monitor;
exports.addMonitoringMessage = internalMonitoring_1.addMonitoringMessage;
var observable_1 = require("./observable");
exports.Observable = observable_1.Observable;
var sessionManagement_1 = require("./sessionManagement");
exports.startSessionManagement = sessionManagement_1.startSessionManagement;
exports.SESSION_TIME_OUT_DELAY = sessionManagement_1.SESSION_TIME_OUT_DELAY;
// Exposed for tests
exports.SESSION_COOKIE_NAME = sessionManagement_1.SESSION_COOKIE_NAME;
exports.stopSessionManagement = sessionManagement_1.stopSessionManagement;
var transport_1 = require("./transport");
exports.HttpRequest = transport_1.HttpRequest;
exports.Batch = transport_1.Batch;
tslib_1.__exportStar(require("./urlPolyfill"), exports);
tslib_1.__exportStar(require("./utils"), exports);
var cookie_1 = require("./cookie");
exports.areCookiesAuthorized = cookie_1.areCookiesAuthorized;
exports.getCookie = cookie_1.getCookie;
exports.setCookie = cookie_1.setCookie;
exports.COOKIE_ACCESS_DELAY = cookie_1.COOKIE_ACCESS_DELAY;
var xhrProxy_1 = require("./xhrProxy");
exports.startXhrProxy = xhrProxy_1.startXhrProxy;
var fetchProxy_1 = require("./fetchProxy");
exports.startFetchProxy = fetchProxy_1.startFetchProxy;
tslib_1.__exportStar(require("./specHelper"), exports);
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@datadog/browser-core/cjs/index.js
// module id = 41
// module chunks = 0